import React from 'react';
import { EmailIcon, EmailShareButton, FacebookIcon, FacebookMessengerIcon, FacebookMessengerShareButton, FacebookShareButton, InstapaperIcon, InstapaperShareButton, LinkedinIcon, LinkedinShareButton, TelegramIcon, TelegramShareButton, TwitterIcon, TwitterShareButton, WhatsappIcon, WhatsappShareButton } from 'react-share';

const ShareButtons = ({ url, title }) => {
  return (
    <div>
        <div className="d-flex flex-wrap align-content-center me-auto">        
      <FacebookShareButton url={url} quote={title}>
        <i className='btn text-light'> <FacebookIcon size={32} round={true} /> </i>
      </FacebookShareButton>

      <WhatsappShareButton url={url} title={title}>
        <i className='btn text-light'> <WhatsappIcon size={32} round={true}/> </i>
      </WhatsappShareButton>
      <EmailShareButton url={url} subject={title} body="Check out this awesome content!">
        <i className='btn text-light'> <EmailIcon size={32} round={true} /></i>
      </EmailShareButton>

      {/* Facebook Messenger Share Button */}
      <FacebookMessengerShareButton url={url}>
        <i className='btn text-light'><FacebookMessengerIcon size={32} round={true} /></i>
      </FacebookMessengerShareButton>

      {/* Instapaper Share Button */}
      <InstapaperShareButton url={url} title={title}>
        <i className='btn text-light'> <InstapaperIcon size={32} round={true} /></i>
      </InstapaperShareButton>

      {/* Telegram Share Button */}
      <TelegramShareButton url={url} title={title}>
        <i className='btn text-light'> <TelegramIcon size={32} round={true} /></i>
      </TelegramShareButton>
      <LinkedinShareButton url={url} title={title}>
        <i className='btn text-light'> <LinkedinIcon size={32} round={true} /></i>
      </LinkedinShareButton>

      {/* Twitter Share Button */}
      <TwitterShareButton url={url} title={title}>
        <i className='btn text-light'> <TwitterIcon size={32} round={true} /></i>
      </TwitterShareButton>
      
      </div>
    </div>
  );
};

export default ShareButtons;
